function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m136 8.007812h112v112h-112zm0 0",
  fill: "#87cee9"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m360 240.007812h32v48h-32zm0 0",
  fill: "#195c85"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m344 288.007812h64v64h-64zm0 0",
  fill: "#50b3c9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m408 312.007812h32v16h-32zm0 0",
  fill: "#aabece"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m432 296.007812h16v48h-16zm0 0",
  fill: "#ffd782"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m248 384.007812h48v32h-48zm0 0",
  fill: "#195c85"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m360 352.007812v24c0 4.417969-3.582031 8-8 8h-56v32h64c17.671875 0 32-14.328124 32-32v-32zm0 0",
  fill: "#195c85"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m288 360.007812h16v80h-16zm0 0",
  fill: "#50b3c9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m24 176.007812c8.835938 0 16 7.164063 16 16v80c0 8.835938-7.164062 16-16 16s-16-7.164062-16-16v-80c0-8.835937 7.164062-16 16-16zm0 0",
  fill: "#dd3e46"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m40 216.007812h64v32h-64zm0 0",
  fill: "#aabece"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m104 200.007812h32v64h-32zm0 0",
  fill: "#7d8d9c"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m136 152.007812h112v160h-112zm0 0",
  fill: "#87cee9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m136 120.007812h112v32h-112zm0 0",
  fill: "#2d75bb"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m248 472.007812h-112v-128h112zm0 0",
  fill: "#87cee9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m248 344.007812h-112v-32h112zm0 0",
  fill: "#2d75bb"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m160 8.007812h16v80h-16zm0 0",
  fill: "#cdeef6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m160 176.007812h16v16h-16zm0 0",
  fill: "#cdeef6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m192 448.007812h-32v-48h16v32h16zm0 0",
  fill: "#cdeef6"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m472 152.007812c0 53.019532-42.980469 96-96 96s-96-42.980468-96-96c0-53.019531 42.980469-96 96-96s96 42.980469 96 96zm0 0",
  fill: "#ffd782"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m423.625 206.007812-10.59375-12c17.472656-15.402343 23.585938-40.011718 15.355469-61.800781-8.234375-21.789062-29.09375-36.207031-52.386719-36.207031s-44.152344 14.417969-52.386719 36.207031c-8.230469 21.789063-2.117187 46.398438 15.355469 61.800781l-10.59375 12c-22.457031-19.808593-30.3125-51.445312-19.726562-79.457031 10.589843-28.007812 37.40625-46.542969 67.351562-46.542969s56.761719 18.535157 67.351562 46.542969c10.585938 28.011719 2.730469 59.648438-19.726562 79.457031zm0 0",
  fill: "#dd3e46"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m338.347656 178.34375 24.003906-24 11.3125 11.3125-24 24.003906zm0 0",
  fill: "#5a6470"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m378.347656 138.351562 24.003906-24 11.3125 11.3125-24 24.003907zm0 0",
  fill: "#5a6470"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m368 200.007812h16v16h-16zm0 0",
  fill: "#fcf05a"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  fill: "#dd3e46"
}, /*#__PURE__*/React.createElement("path", {
  d: "m368 64.007812h16v24h-16zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m314.34375 85.664062 11.316406-11.3125 24 24-11.3125 11.316407zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m402.347656 98.34375 24-24 11.316406 11.3125-24.003906 24.003906zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m277.019531 127.433594 5.941407-14.855469 40 16-5.941407 14.855469zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m436.425781 136.847656 32-16 7.152344 14.3125-31.996094 16zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m284.425781 184.851562 32-16 7.15625 14.3125-32 16zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m428.421875 183.160156 7.15625-14.3125 32 16-7.15625 14.3125zm0 0"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m392 152.007812c0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-8.835937 7.164062-16 16-16s16 7.164063 16 16zm0 0",
  fill: "#e97424"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m376 48.007812c-52.761719-.035156-97.179688 39.460938-103.308594 91.863282-6.132812 52.402344 27.964844 101.085937 79.308594 113.230468v26.90625h-8c-4.417969 0-8 3.582032-8 8v64c0 4.417969 3.582031 8 8 8h8v16h-48v-16h-16v16h-32v-368c0-4.417968-3.582031-7.9999995-8-7.9999995h-112c-4.417969 0-8 3.5820315-8 7.9999995v184h-24c-4.417969 0-8 3.582032-8 8v8h-48v-16c0-13.253906-10.746094-24-24-24s-24 10.746094-24 24v80c0 13.253907 10.746094 24 24 24s24-10.746093 24-24v-16h48v8c0 4.417969 3.582031 8 8 8h24v200c0 4.417969 3.582031 8 8 8h112c4.417969 0 8-3.582031 8-8v-48h32v16h16v-16h56c22.082031-.027343 39.972656-17.921874 40-40v-24h8c4.417969 0 8-3.582031 8-8v-24h16v16h16v-48h-16v16h-16v-24c0-4.417968-3.582031-8-8-8h-8v-26.90625c51.34375-12.144531 85.441406-60.828124 79.308594-113.230468-6.128906-52.402344-50.546875-91.898438-103.308594-91.863282zm83.785156 77.167969-14.554687 7.269531c-3.667969-12.90625-10.875-24.527343-20.796875-33.558593l11.308594-11.3125c11.105468 10.265625 19.382812 23.214843 24.042968 37.601562zm4.214844 26.832031c-.015625 9.742188-1.664062 19.414063-4.871094 28.617188l-14.402344-7.203125c2.167969-6.929687 3.273438-14.152344 3.273438-21.414063 0-1.007812-.113281-1.984374-.152344-2.976562l15.433594-7.71875c.457031 3.546875.699219 7.117188.71875 10.695312zm-123.34375-62.65625-11.632812-11.632812c11.746093-7.480469 25.109374-12.042969 38.976562-13.304688v16.066407c-9.621094 1.070312-18.925781 4.089843-27.34375 8.871093zm43.34375-8.871093v-16.066407c13.867188 1.261719 27.230469 5.824219 38.976562 13.304688l-11.632812 11.632812c-8.417969-4.78125-17.722656-7.800781-27.34375-8.871093zm-67.742188 7.09375 11.308594 11.3125c-7.519531 6.835937-13.515625 15.179687-17.597656 24.488281l-14.871094-5.945312c4.894532-11.316407 12.101563-21.484376 21.160156-29.855469zm-28.257812 64.433593c.015625-6.496093.753906-12.972656 2.199219-19.304687l15.082031 6.03125c-2.234375 11.546875-1.535156 23.46875 2.03125 34.671875l-14.402344 7.199219c-3.21875-9.191407-4.878906-18.859375-4.910156-28.597657zm-48-8h-96v-16h96zm-96 16h96v144h-96zm0 160h96v16h-96zm0-304h16v72h16v-72h64v96h-96zm-112 256c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8v-80c0-4.417968 3.582031-8 8-8s8 3.582032 8 8zm16-32v-16h48v16zm64 16v-48h16v48zm128 208h-96v-112h96zm16-72h32v16h-32zm128-8c0 13.253907-10.746094 24-24 24h-56v-16h48c8.835938 0 16-7.164062 16-16v-16h16zm16-40h-48v-48h48zm-16-64h-16v-24.410156c2.648438.210938 5.296875.410156 8 .410156s5.351562-.199218 8-.410156zm-8-40c-31.730469-.039062-60.984375-17.15625-76.558594-44.800781l14.277344-7.136719c3.882812 6.726563 8.835938 12.773438 14.65625 17.914063l10.59375-12c-17.472656-15.402344-23.585938-40.011719-15.355469-61.800781 8.234375-21.789063 29.09375-36.207032 52.386719-36.207032s44.152344 14.417969 52.386719 36.207032c8.230469 21.789062 2.117187 46.398437-15.355469 61.800781l10.59375 12c5.820312-5.140625 10.773438-11.1875 14.65625-17.914063l14.277344 7.136719c-15.574219 27.644531-44.828125 44.761719-76.558594 44.800781zm0 0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m413.65625 125.664062-11.3125-11.3125-16.0625 16.054688c-3.203125-1.566406-6.71875-2.386719-10.28125-2.398438-13.253906 0-24 10.746094-24 24 .015625 3.5625.835938 7.078126 2.398438 10.28125l-16.0625 16.0625 11.3125 11.3125 16.070312-16.058593c3.203125 1.566406 6.71875 2.386719 10.28125 2.402343 13.253906 0 24-10.746093 24-24-.015625-3.566406-.835938-7.078124-2.398438-10.28125zm-37.65625 34.34375c-4.417969 0-8-3.582031-8-8 0-4.417968 3.582031-8 8-8s8 3.582032 8 8c0 4.417969-3.582031 8-8 8zm0 0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m368 200.007812h16v16h-16zm0 0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m160 176.007812h16v16h-16zm0 0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m176 400.007812h-16v48h32v-16h-16zm0 0"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "-240 -230 940 940"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);

export default __webpack_public_path__ + "static/media/gauge.b3ca2624.svg";
export { SvgComponent as ReactComponent };